'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function SaleComponent($http, AppConstants) {
	'ngInject';

	var service = {
		'fetchTickets': fetchTickets,
		'fetchTicket': fetchTicket,
		'getTickets': getTickets,
		'getPaginationInfo': getPaginationInfo,
		'clearTickets': clearTickets
	};

	var tickets = [];
	var paginationInfo = {};

	return service;

	function fetchTickets(searchParams) {
		var page = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];

		var keys = Object.keys(searchParams);
		var params = {
			'params': {
				'per_page': 60,
				'page': page,
				'sort': '-id'
			}
		};

		keys.forEach(function (val) {
			if (searchParams[val]) {
				params.params[val] = searchParams[val];
			}
		});

		return $http.get(AppConstants.apiUrl + '/sales', params).then(setTickets)['catch'](failedRequest);
	}

	function fetchTicket(ticketId) {
		var params = {
			'params': {
				'with': 'discount'
			}
		};

		return $http.get(AppConstants.apiUrl + '/sales/' + ticketId, params).then(setTickets)['catch'](failedRequest);
	}

	function getTickets() {
		return tickets;
	}

	function setTickets(data) {
		paginationInfo.page_size = data.data.per_page;
		paginationInfo.page = data.data.current_page;
		paginationInfo.total = data.data.total;
		tickets = data.data.data;

		return data;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function failedRequest(requestError) {
		return requestError;
	}

	function clearTickets() {
		tickets = [];
	}
}

exports['default'] = SaleComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/sale/sale.service.js
 **/